"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _pickers = require("@material-ui/pickers");

var _dateFns = _interopRequireDefault(require("@date-io/date-fns"));

var _de = _interopRequireDefault(require("date-fns/locale/de"));

var _dateFns2 = require("date-fns");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var TsDatePicker = function TsDatePicker(_ref) {
  var _ref$value = _ref.value,
      value = _ref$value === void 0 ? null : _ref$value,
      _ref$name = _ref.name,
      name = _ref$name === void 0 ? "" : _ref$name,
      _ref$label = _ref.label,
      label = _ref$label === void 0 ? "" : _ref$label,
      handleChange = _ref.handleChange,
      _ref$dateFormat = _ref.dateFormat,
      dateFormat = _ref$dateFormat === void 0 ? "dd.MM.yyyy" : _ref$dateFormat,
      _ref$disableFuture = _ref.disableFuture,
      disableFuture = _ref$disableFuture === void 0 ? true : _ref$disableFuture;

  var _useState = (0, _react.useState)(value ? new Date() : null),
      _useState2 = _slicedToArray(_useState, 2),
      selectedDate = _useState2[0],
      setSelectedDate = _useState2[1];

  (0, _react.useEffect)(function () {
    setSelectedDate(value ? new Date(value) : null);
  }, [value]);

  var handleDateChange = function handleDateChange(date) {
    setSelectedDate(date);

    if ((0, _dateFns2.isValid)(date)) {
      var formattedDate = (0, _dateFns2.format)(date, "yyyy-MM-dd");
      handleChange(name, formattedDate)();
    }
  };

  return _react.default.createElement(_pickers.MuiPickersUtilsProvider, {
    utils: _dateFns.default,
    locale: _de.default
  }, _react.default.createElement(_pickers.KeyboardDatePicker, {
    fullWidth: true,
    disableFuture: disableFuture,
    invalidDateMessage: "ung\xFCltiges Datum",
    inputVariant: "outlined",
    margin: "dense",
    id: "date-picker-dialog",
    label: label,
    cancelLabel: "Abbrechen",
    format: dateFormat,
    value: selectedDate,
    onChange: function onChange(date) {
      return handleDateChange(date);
    },
    KeyboardButtonProps: {
      "aria-label": "change date"
    }
  }));
};

var _default = TsDatePicker;
exports.default = _default;

//# sourceMappingURL=TsDatePicker.jsx.map